(() => {
  const KEY = 'cb_favorites_v1';
  const config = JSON.parse(document.getElementById('cb-favorites-config').textContent);
  const labels = config.labels;
  const root = config.root.replace(/\/?$/, '/');
  const currentProducts = new Map();
  let renderVersion = 0;
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.5a5.5 5.5 0 0 0 0-7.8Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const safeHandle = value => /^[a-z0-9][a-z0-9-]*$/.test(value || '');
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '{}');
      return data && typeof data === 'object' && !Array.isArray(data) ? data : {};
    } catch (_) { return {}; }
  };
  const write = data => {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) { return false; }
    update();
    return true;
  };
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const favoriteKey = (list, handle, id) => list[handle] ? handle : (id ? Object.keys(list).find(key => String(list[key]?.id) === String(id)) : undefined);
  const requestProduct = async path => {
    const response = await fetch(path + '.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Product unavailable');
    const p = await response.json();
    if (!p.id || !Number.isFinite(Number(p.price))) throw new Error('Invalid product');
    return p;
  };
  const resolveLocalizedProduct = async (handle, saved) => {
    try { return await requestProduct(productUrl(handle)); }
    catch (originalError) {
      // Translated handles differ between languages sharing the same domain.
      const roots = [...new Set([saved?.sourceRoot, ...(config.languageRoots || [])])]
        .filter(value => typeof value === 'string' && /^\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/?$/i.test(value))
        .map(value => value.replace(/\/?$/, '/'));
      for (const sourceRoot of roots) {
        try {
          const response = await fetch(sourceRoot + 'products/' + encodeURIComponent(handle), { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) continue;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const alternate = [...page.querySelectorAll('link[rel="alternate"][hreflang]')].find(link => {
            const language = link.getAttribute('hreflang').split('-')[0].toLowerCase();
            const url = new URL(link.getAttribute('href'), location.origin);
            return language === config.locale.split('-')[0].toLowerCase() && url.origin === location.origin && url.pathname.startsWith(root + 'products/');
          });
          if (!alternate) continue;
          return await requestProduct(new URL(alternate.getAttribute('href'), location.origin).pathname);
        } catch (_) { /* Try another published language path; never show a stale price. */ }
      }
      throw originalError;
    }
  };
  const productData = handle => {
    if (!currentProducts.has(handle)) {
      const saved = read()[handle];
      const localizedHandle = safeHandle(saved?.handles?.[config.locale]) ? saved.handles[config.locale] : handle;
      const request = resolveLocalizedProduct(localizedHandle, saved).then(p => {
        if (saved?.id && String(saved.id) !== String(p.id)) throw new Error('Product identity changed');
        return { id: p.id, handle: p.handle || handle, title: p.title, image: p.featured_image || (p.images && p.images[0]) || '', price: Number(p.price), priceVaries: !!p.price_varies };
      }).catch(error => { currentProducts.delete(handle); throw error; });
      currentProducts.set(handle, request);
    }
    return currentProducts.get(handle);
  };
  const money = cents => new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(cents / 100);
  const toggle = async (button, handle) => {
    const list = read();
    const existingKey = favoriteKey(list, handle, button.dataset.favoriteProductId);
    if (existingKey) {
      delete list[existingKey];
      write(list);
      return;
    }
    button.disabled = true;
    try {
      const item = await productData(handle);
      const next = read();
      if (!favoriteKey(next, handle, item.id)) next[handle] = { id: item.id, handle, title: item.title, image: item.image, sourceRoot: root, handles: { [config.locale]: item.handle } };
      if (!write(next)) throw new Error('Storage unavailable');
    } catch (_) {
      button.setAttribute('aria-label', labels.save_error);
    } finally { button.disabled = false; }
  };
  const addButton = (target, handle, mode, id) => {
    if (!safeHandle(handle) || target.querySelector(':scope > .cb-favorite-toggle')) return false;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'cb-favorite-toggle cb-favorite-toggle--' + mode;
    button.dataset.favoriteHandle = handle;
    if (id) button.dataset.favoriteProductId = String(id);
    button.innerHTML = heart;
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      toggle(button, handle);
    });
    target.append(button);
    return true;
  };
  const enhance = () => {
    let added = false;
    document.querySelectorAll('.product-card[data-product], .card-extended-wrapper[data-product]').forEach(card => {
      const handle = card.getAttribute('data-product');
      const target = card.querySelector('.card__inner, .card-extended__inner') || card;
      added = addButton(target, handle, 'card', card.dataset.favoriteProductId) || added;
    });
    const path = location.pathname.match(/\/products\/([a-z0-9-]+)/);
    if (path) {
      const gallery = document.querySelector('.product__media-list-wrapper');
      if (gallery) added = addButton(gallery, path[1], 'product', config.productId) || added;
    }
    if (added) update();
  };
  const renderPage = async list => {
    const grid = document.getElementById('cb-favorites-grid');
    if (!grid) return;
    const version = ++renderVersion;
    grid.replaceChildren();
    const items = Object.values(list).filter(item => item && safeHandle(item.handle));
    const empty = document.getElementById('cb-favorites-empty');
    if (empty) empty.hidden = items.length > 0;
    if (!items.length) { grid.removeAttribute('aria-busy'); return; }
    grid.setAttribute('aria-busy', 'true');
    const loading = document.createElement('p');
    loading.textContent = labels.loading;
    grid.append(loading);
    const results = new Array(items.length);
    let cursor = 0;
    await Promise.all(Array.from({ length: Math.min(4, items.length) }, async () => {
      while (cursor < items.length) {
        const index = cursor++;
        try { results[index] = { ...await productData(items[index].handle), savedHandle: items[index].handle }; }
        catch (_) { results[index] = { ...items[index], unavailable: true, savedHandle: items[index].handle }; }
      }
    }));
    if (version !== renderVersion) return;
    grid.replaceChildren();
    grid.removeAttribute('aria-busy');
    // Upgrade old saved items with a stable ID without restoring concurrently removed items.
    const latest = read();
    let upgraded = false;
    results.forEach(item => {
      if (!item.unavailable && latest[item.savedHandle] && (!latest[item.savedHandle].id || latest[item.savedHandle].handles?.[config.locale] !== item.handle)) {
        latest[item.savedHandle].id = item.id;
        latest[item.savedHandle].handles = { ...(latest[item.savedHandle].handles || {}), [config.locale]: item.handle };
        upgraded = true;
      }
    });
    if (upgraded) { try { localStorage.setItem(KEY, JSON.stringify(latest)); } catch (_) {} }
    results.forEach(item => {
      const article = document.createElement('article');
      article.className = 'cb-favorite-card';
      const link = document.createElement('a');
      link.href = productUrl(item.handle);
      link.className = 'cb-favorite-card__link';
      if (item.image && /^(https?:)?\/\//.test(item.image)) {
        const img = document.createElement('img');
        img.src = item.image.startsWith('//') ? 'https:' + item.image : item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        link.append(img);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'cb-favorite-card__placeholder';
        placeholder.textContent = labels.image;
        link.append(placeholder);
      }
      const title = document.createElement('h2');
      title.textContent = item.title || item.handle;
      link.append(title);
      article.append(link);
      if (!item.unavailable && Number.isFinite(item.price)) {
        const price = document.createElement('p');
        price.textContent = (item.priceVaries ? labels.from + ' ' : '') + money(item.price);
        article.append(price);
      }
      if (item.unavailable) {
        const message = document.createElement('p');
        message.textContent = labels.unavailable;
        article.append(message);
      }
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cb-favorite-remove';
      remove.textContent = labels.remove;
      remove.addEventListener('click', () => {
        const next = read();
        delete next[item.savedHandle];
        write(next);
      });
      article.append(remove);
      grid.append(article);
    });
  };
  function update() {
    const list = read();
    document.querySelectorAll('.cb-favorite-toggle').forEach(button => {
      const active = !!favoriteKey(list, button.dataset.favoriteHandle, button.dataset.favoriteProductId);
      button.classList.toggle('is-favorite', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? labels.remove : labels.add);
    });
    const count = document.querySelector('.cb-favorites-count');
    if (count) {
      const length = Object.keys(list).length;
      count.textContent = String(length);
      count.hidden = length === 0;
    }
    renderPage(list);
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; enhance(); });
  });
  document.addEventListener('DOMContentLoaded', () => {
    enhance();
    update();
    observer.observe(document.body, { childList: true, subtree: true });
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { currentProducts.clear(); update(); } });
  window.addEventListener('storage', event => { if (event.key === KEY) update(); });
})();

